import { Link } from "react-router-dom";
import { ArrowUpRight, Newspaper, PenLine } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { formatPostDate } from "@/lib/api";

export const PostCard = ({ post, testId, large = false }) => {
  const { t, lang } = useLang();
  const Icon = post.category === "news" ? Newspaper : PenLine;
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={testId}
      className="group flex h-full flex-col overflow-hidden rounded-md border border-line bg-card2 transition-colors duration-300 hover:border-ember/60"
    >
      {post.cover_image ? (
        <div className="relative aspect-[16/9] overflow-hidden">
          <img src={post.cover_image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
        </div>
      ) : (
        <div className="flex aspect-[16/9] items-center justify-center bg-black/40">
          <Icon className="h-8 w-8 text-ember/70" />
        </div>
      )}
      <div className="flex flex-1 flex-col p-5 md:p-6">
        <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ember">
          {t.blog.categories[post.category]}
          <span className="h-1 w-1 rotate-45 bg-ember/60" aria-hidden="true" />
          <span className="text-ash">{formatPostDate(post.created_at, lang)}</span>
        </p>
        <h3 className={`mt-3 font-display font-bold leading-snug text-cream transition-colors duration-300 group-hover:text-emberHover ${large ? "text-2xl md:text-3xl" : "text-lg md:text-xl"}`}>
          {post.title}
        </h3>
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-ash">{post.excerpt}</p>
        <span className="mt-auto flex items-center gap-2 pt-5 text-xs font-semibold uppercase tracking-wider text-ember">
          {t.blog.readMore}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
};
